import React from 'react';

import { ESimulationClient } from '../../types/entities.enum';

export const LogoPackage = () => {

    if (window.location.origin.startsWith(`https://${ESimulationClient.PROSPR}`)) {
        return (
            <div className='logo_package logo_package--prospr'>
                <img src="/assets/logos/prospr.svg" alt="Prosp-r" />
                <h6>Powered by <span>MindShield</span></h6>
            </div>
        );
    };

    if (window.location.origin.startsWith(`https://${ESimulationClient.RIDLEY_CONSULTING}`)) {
        return (
            <div className='logo_package logo_package--ridley'>
                <img src="/assets/logos/ridley.svg" alt="Ridley" />
                <h6>Powered by <span>MindShield</span></h6>
            </div>
        );
    };

    return (
        <div className='logo_package logo_package--mindshield'>
            <img src="/assets/logos/mindshield.svg" alt="MindShield" />
        </div>
    );
};

export const LogoPackageHoriz = () => {

    if (window.location.origin.startsWith(`https://${ESimulationClient.PROSPR}`)) {
        return (
            <div className='logo_package__horiz logo_package__horiz--prospr'>
                <img src="/assets/logos/prospr-horiz.svg" alt="Prosp-r" />
            </div>
        );
    };

    if (window.location.origin.startsWith(`https://${ESimulationClient.RIDLEY_CONSULTING}`)) {
        return (
            <div className='logo_package__horiz logo_package__horiz--ridley'>
                <img src="/assets/logos/ridley-horiz.svg" alt="Ridley" />
            </div>
        );
    };

    return (
        <div className='logo_package__horiz logo_package__horiz--mindshield'>
            <img src="/assets/logos/mindshield-horiz.svg" alt="MindShield" />
        </div>
    );
};